import { TSelectedMenu } from "components/uis/sidebar/Sidebar";
import { UserSetting, UserSettingId } from "helpers/usersettings/UserSetting";

export const SidebarCollapsedSetting = new UserSetting<boolean>(
  UserSettingId.IsSidebarCollpased
);

export const SelectedMenu = new UserSetting<TSelectedMenu>(
  UserSettingId.selectedMenu
);
